import * as dotenv from 'dotenv';

dotenv.config();

export const BASE_API_URL: string = process.env.REACT_APP_BASE_API_URL || '';
export const BASE_UPLOAD_URL: string = process.env.REACT_APP_BASE_UPLOAD_URL || '';
